<template>
    <el-container>
		<div class="edit-text">
			<editor v-model="textarea2"
			    @init="editorInit"
			    :options="{wrap: true}"
			    lang="text"
				:theme="editorTheme"
			    width="100%"
			    height="100%">
			</editor>
		</div>
        <div style="margin: 15px 0px;">
            <el-button-group>
                <el-button type="primary" @click="toLocaleUpperCase">全大写</el-button>
                <el-button type="primary" @click="toLocaleLowerCase">全小写</el-button>
                <el-button type="primary" @click="toCapitalizeTheFirstLetter">首字母大写</el-button>
                <el-button type="primary" @click="spaceToUnderline">空格转下划线</el-button>
                <el-button type="primary" @click="underlineToSpace">下划线转空格</el-button>
                <el-button type="primary" @click="toHump">下划线转驼峰</el-button>
                <el-button type="primary" @click="toLine">驼峰转下划线</el-button>
                <el-button type="primary" @click="spaceToHump">空格转驼峰</el-button>
                <el-button type="primary" @click="humpToSpace">驼峰转空格</el-button>
            </el-button-group>
        </div>
		<div class="edit-text">
			<editor v-model="resultText"
			    @init="editorInit"
			    :options="{wrap: true}"
			    lang="text"
				:theme="editorTheme"
			    width="100%"
			    height="100%">
			</editor>
		</div>
    </el-container>
</template>

<script>
export default {
    name: "g-textTool",
    data() {
        return {
            textarea2:"",
			resultText:'',
        };
    },
	components: {
		editor: require('vue2-ace-editor'),
	},
    methods: {
        // 全大写
        toLocaleUpperCase(){
            this.resultText = this.textarea2.toLocaleUpperCase();
        },
        // 全小写
        toLocaleLowerCase(){
            this.resultText = this.textarea2.toLocaleLowerCase();
        },
        // 首字母大写
        toCapitalizeTheFirstLetter(){
            this.resultText = this.textarea2.toLocaleLowerCase().replace(this.textarea2[0],this.textarea2[0].toLocaleUpperCase());
        },
        // 空格转下划线
        spaceToUnderline(){
            this.resultText = this.textarea2.replaceAll(" ","_");
        },
        // 下划线转空格
        underlineToSpace(){
            this.resultText = this.textarea2.replaceAll("_"," ");
        },
        // 下划线转驼峰
        toHump(){
            this.resultText = this.textarea2.replace(/\_(\w)/g, function($0,$1){
                return $1.toUpperCase();
            });
        },
        // 驼峰转下划线
        toLine(){
            this.resultText = this.textarea2.replace(/([A-Z])/g,"_$1").toLowerCase();
        },
        spaceToHump(){
            this.resultText = this.textarea2.replace(/\s+(\w)/g, function($0,$1){
                return $1.toUpperCase();
            });
        },
        humpToSpace(){
            this.resultText = this.textarea2.replace(/([A-Z])/g," $1").toLowerCase();
        },
	},
    mounted() {
        
    },
};
</script>
<style lang="scss" scoped>
	.el-container /deep/{
		flex-flow: column;
		display: flex;
		
		.edit-text{
			flex: 1;
			display: flex;
			border: 1px solid #DCDFE6;
			border-radius: 3px;
			overflow: hidden;
		}
	}
</style>
